module.exports = __webpack_public_path__ + "img/mayas_to.70a59130.png";